// Copyright © 2025 The Things Industries B.V.

export const getContrastingTextColor = hexColor => {
  // Expand shorthand form (e.g., "03F") to full form ("0033FF")
  let completeHexColor = hexColor
  // Remove the '#' if present
  if (hexColor.startsWith('#')) {
    completeHexColor = hexColor.slice(1)
  }
  if (hexColor.length === 3) {
    completeHexColor = hexColor
      .split('')
      .map(char => char + char)
      .join('')
  }

  // Convert the hex string to red, green, and blue values
  const r = parseInt(completeHexColor.substr(0, 2), 16)
  const g = parseInt(completeHexColor.substr(2, 2), 16)
  const b = parseInt(completeHexColor.substr(4, 2), 16)

  // Calculate brightness using the YIQ formula
  const brightness = (r * 299 + g * 587 + b * 114) / 1000

  return { textColor: brightness > 131 ? '#000000' : '#ffffff', withBorder: brightness >= 240 }
}

export const generateRandomHexColor = () =>
  `#${Math.floor(Math.random() * 16777215)
    .toString(16)
    .padStart(6, '0')}`
